import PinLocation from "./PinLocation";

export default PinLocation;
